// Shared table body states: skeleton while loading, error with retry, and an
// empty state that tells "nothing exists yet" apart from "no filter matches".
// Render inside <tbody> when there are no rows to show:
//   <TableState colSpan={9} loading={loading} error={error} onRetry={reload}
//     emptyTitle="No vendors yet" emptyHint="Add your first vendor to get started."
//     emptyAction={{ label: 'New Vendor', onClick: openCreate }}
//     filtered={hasActiveFilters} onClearFilters={clearFilters} />

const SkeletonRows = ({ colSpan, rows = 4 }) => (
  <>
    {Array.from({ length: rows }, (_, i) => (
      <tr key={i}>
        <td colSpan={colSpan} style={{ padding: '13px 18px' }}>
          <div className="skeleton-line" style={{ width: `${88 - i * 9}%` }} />
        </td>
      </tr>
    ))}
  </>
);

const CenterCell = ({ colSpan, children }) => (
  <tr>
    <td colSpan={colSpan} style={{ padding: '48px 24px', textAlign: 'center' }}>
      {children}
    </td>
  </tr>
);

const TableState = ({
  colSpan,
  loading,
  error,
  onRetry,
  emptyTitle = 'Nothing here yet',
  emptyHint,
  emptyAction,
  filtered,
  onClearFilters,
}) => {
  if (loading) return <SkeletonRows colSpan={colSpan} />;

  if (error) {
    return (
      <CenterCell colSpan={colSpan}>
        <div style={{
          fontFamily: 'var(--font-sans)', fontSize: '14px', fontWeight: 500,
          color: 'var(--danger)', marginBottom: '4px',
        }}>
          {error}
        </div>
        <div style={{
          fontFamily: 'var(--font-sans)', fontSize: '13px',
          color: 'var(--muted)', marginBottom: onRetry ? '16px' : 0,
        }}>
          Check your connection and try again.
        </div>
        {onRetry && (
          <button type="button" className="btn-secondary" onClick={onRetry}>
            Try again
          </button>
        )}
      </CenterCell>
    );
  }

  if (filtered) {
    return (
      <CenterCell colSpan={colSpan}>
        <div style={{
          fontFamily: 'var(--font-serif)', fontSize: '19px', fontWeight: 500,
          color: 'var(--ink)', letterSpacing: '-0.2px', marginBottom: '4px',
        }}>
          No matches
        </div>
        <div style={{
          fontFamily: 'var(--font-sans)', fontSize: '13px',
          color: 'var(--muted)', marginBottom: onClearFilters ? '16px' : 0,
        }}>
          No results match the current filters.
        </div>
        {onClearFilters && (
          <button type="button" className="btn-secondary" onClick={onClearFilters}>
            Clear filters
          </button>
        )}
      </CenterCell>
    );
  }

  return (
    <CenterCell colSpan={colSpan}>
      <div style={{
        fontFamily: 'var(--font-serif)', fontSize: '19px', fontWeight: 500,
        color: 'var(--ink)', letterSpacing: '-0.2px', marginBottom: '4px',
      }}>
        {emptyTitle}
      </div>
      {emptyHint && (
        <div style={{
          fontFamily: 'var(--font-sans)', fontSize: '13px',
          color: 'var(--muted)', marginBottom: emptyAction ? '16px' : 0,
        }}>
          {emptyHint}
        </div>
      )}
      {emptyAction && (
        <button type="button" className="btn-primary" onClick={emptyAction.onClick}>
          {emptyAction.label}
        </button>
      )}
    </CenterCell>
  );
};

export default TableState;
